<template>
	<div class="content-wrap">
		<!-- 搜索表单 -->
		<search-form
			@search="search"
			ref="BillSearchRef"
			class="searchform-style customer-list-form"
		></search-form>

		<!-- 按钮组（在 billsReceivableTable 的 toolbar 中） -->
		<!-- table展示区 -->
		<div style="height:75%;" class="table-scroll-wrap">
			<billsReceivableTable
				:isSelect="true"
				:loading="loading"
				:tableData="tableData"
				:tableColumn="columns"
				:columnSettingsKey="$route.name"
				@onSelectChange="onSelectChange"
				:pagination="pagination"
				v-bind:class="isActive ? 'active' : 'static'"
			>
				<template v-slot:toolbar>
					<billsButtons
						ref="controlBut"
						:selectedRows="selectedRows"
						@success="success"
					></billsButtons>
				</template>
			</billsReceivableTable>
		</div>
	</div>
</template>
<script>
import searchForm from "./components/searchForm";
import billsReceivableTable from "./components/bills-receivable-table.vue";
import billsButtons from "./components/bills-buttons.vue";
import { queryBillingReportList } from "../../api/receivable";
import { columns } from "./bills-receivable";
import { searchReqParam } from "../../utils/searchReqParam";

export default {
	name: "business-dispatch",
	components: { billsReceivableTable, searchForm, billsButtons },
	data() {
		return {
			columns,
			req: searchReqParam(),
			loading: false,
			tableData: [],
			selectedRows: [],
			pagination: {
				showSizeChanger: true,
				defaultPageSize: 10,
				pageSizeOptions: ["10", "15", "50", "100"],
				total: 0,
				current: 1,
				showTotal: (total) => this.$t('totalText', { total }),
				onChange: (page) => {
					this.pagination.current = page;
					this.req.params.page = page;
					this.pageInit();
				},
				onShowSizeChange: (current, pageSize) => {
					this.pagination.current = 1;
					this.req.params.page = 1;
					this.req.params.pageSize = pageSize;
					this.pageInit();
				},
			},
			visibleAttach: false,
			attach: [],
			current: 1,
			currentValue: 1,
			rotateTimes: 0,
			multiples: 1,
			imgStyle: "",
			containerId: "",
			blNumber: "",
			isActive: true,
		};
	},
	watch: {
		loading: {
			handler() {
				this.isActive = !this.loading;
			}
		}
	},
	created() {},
	mounted() {
		this.pageInit();
	},
	methods: {
		// 初始化页面
		pageInit() {
			this.req.params = this.$refs["BillSearchRef"].params;
			this.loading = true;
			console.log(this.req);
			queryBillingReportList(this.req).then((res) => {
				let temp = JSON.parse(res.data);
				if (!temp.success || temp.code != 0) {
					this.$message.error(temp.msg);
					return;
				}
				this.loading = false;
				this.tableData = temp.data.list;
				// this.containerId = this.tableData.containerId;
				this.pagination.total = JSON.parse(res.data).data.total;
			});
		},
		// 表单搜索
		search(data) {
			this.req.params = data.params;
			this.pageInit();
		},
		onSelectChange(selectedRows) {
			this.selectedRows = selectedRows;
		},
		success(msg) {
			console.log(msg);
			this.pageInit();
		},
		// 关闭附件预览弹框
		closeAttach() {
			this.visibleAttach = false;
			this.current = 1;
			this.currentValue = 1;
			this.attach = [];
			this.imgStyle = "";
		},
	},
};
</script>

<style lang="less" scoped>
// 搜索区固定左贴边
.searchform-style {
	position: sticky;
	left: 0;
	padding: 24px 24px 0px 24px;
	z-index: 101;
}
// table样式
.content-wrap {
	overflow: auto;
    width: 100%;
    height: 100%;
}
// 去除 table 底部多出默认边框
/deep/.ant-table-small.ant-table-bordered {
	border-bottom: 0;
}
// 按钮吸顶
.control-tabs {
	height: 40px;
	position: -webkit-sticky;
	position: sticky;
	top: 0;
	left: 0;
	background: white;
	z-index: 100;
	padding: 0 24px;
	display: flex;
	align-items: center;
}
// 表格吸顶
.table-scroll-wrap {
	position: -webkit-sticky;
	position: sticky;
	top: 40px;
	padding: 0 24px;
}
/deep/ .ant-table-thead {
	position: sticky;
	top: 40px;
	background: #f5f5f5;
	z-index: 100;
}
.active {
	/deep/.ant-table-thead {
		position: sticky;
		top: 40px;
		background: #f5f5f5;
		z-index: 100;
	}
}
.static {
	/deep/.ant-table-thead {
		position: static;
		top: 0px;
		background: #f5f5f5;
		z-index: 100;
	}
}

/deep/.ant-table-small.ant-table-bordered .ant-table-content {
	border-right: none !important;
}
</style>
